import {
  IScheduledSectionComponent,
  TScreensGridSections,
} from '../../ScheduleComponentPage.interface';
import { ISidePanelItem, ISidePanelItemListProps } from './modules/sidePanel';

export const getSelectedLocationGroupIds = (
  selectedLocationGroups: Set<number | string>,
  selectedLocationGroupId?: number | string,
) => {
  const ids = new Set<number>();

  selectedLocationGroups.forEach((id) => ids.add(Number(id)));

  if (!!selectedLocationGroupId) {
    ids.add(Number(selectedLocationGroupId));
  }

  return Array.from(ids).filter((id) => Number.isFinite(id));
};

const getItemsForPosition = (
  position: string,
  positionData: TScreensGridSections[string],
): ISidePanelItem[] => {
  return Object.entries(positionData).flatMap(([screenIndex, sections]) => {
    return sections.flatMap((section) => {
      return (
        section.components
          ?.filter((comp) => comp.component)
          .map((comp) => ({
            ...(comp as IScheduledSectionComponent),
            screenIndex: Number(screenIndex),
            position,
          })) || []
      );
    });
  });
};

export const generateSidePanelData = (
  screensGridSections: TScreensGridSections,
): ISidePanelItemListProps[] => {
  const result: ISidePanelItemListProps[] = [];

  Object.entries(screensGridSections).forEach(([position, positionData]) => {
    const items = getItemsForPosition(position, positionData);

    if (items.length > 0) {
      result.push({
        title: `Position ${position}`,
        items,
      });
    }
  });

  return result;
};
